import { z } from 'zod';

export const earlyPaySettingsSchema = z.object({
    defaultDiscount: z.number(),
    bufferCZK: z.number(),
});

const bankSchema = z.enum(['kb', 'fio']);

const earlyPayUnavailableSourcesSchema = z.object({
    banks: z.array(bankSchema),
    expectedIncomeCount: z.number(),
    liabilityCount: z.number(),
    fixedCostCount: z.number(),
    vatCount: z.number(),
});

export const earlyPayOverviewSchema = z.object({
    defaultDiscount: z.number(),
    bufferCZK: z.number(),
    discount: z.number(),
    capacityCZK: z.number().nullable(),
    freeCapacityCZK: z.number().nullable(),
    proposedEarlyPayLiabilityCZK: z.number().nullable(),
    capacityAfterOfferCZK: z.number().nullable(),
    isCapacityExceeded: z.boolean().nullable(),
    reservedCZK: z.number(),
    reservedCommissionCount: z.number(),
    isComplete: z.boolean(),
    capacityQuality: z.enum(['exact', 'estimated', 'unavailable']).default('exact'),
    estimatedSources: z
        .object({
            liabilityVatCount: z.number(),
        })
        .default({ liabilityVatCount: 0 }),
    unavailableSources: earlyPayUnavailableSourcesSchema,
    carrierStatistics: z.object({
        offeredCount: z.number(),
        acceptedCount: z.number(),
        lastAcceptedAt: z.number().nullable(),
    }),
});

export const earlyPayDashboardSchema = z.object({
    defaultDiscount: z.number(),
    bufferCZK: z.number(),
    availableCashCZK: z.number().nullable(),
    accountsBalanceCZK: z.number().nullable(),
    expectedIncomeCZK: z.number(),
    liabilitiesCZK: z.number(),
    fixedCostsCZK: z.number(),
    vatCZK: z.number(),
    reservedCZK: z.number(),
    reservedCommissionCount: z.number(),
    capacityCZK: z.number().nullable(),
    freeCapacityCZK: z.number().nullable(),
    isComplete: z.boolean(),
    capacityQuality: z.enum(['exact', 'estimated', 'unavailable']),
    estimatedSources: z.object({
        liabilityVatCount: z.number(),
    }),
    unavailableSources: earlyPayUnavailableSourcesSchema,
    fetchedAt: z.number(),
});

export type TEarlyPaySettings = z.infer<typeof earlyPaySettingsSchema>;
export type TEarlyPayOverview = z.infer<typeof earlyPayOverviewSchema>;
export type TEarlyPayDashboard = z.infer<typeof earlyPayDashboardSchema>;

export type TGetEarlyPayOverviewRequest = {
    commissionId: number;
    discount?: number;
};
